export default "__VITE_ASSET__61d1aa4d__"